import api from "./apiURL";

export async function getApiLogs(lineLimit = 100) {
  try {
    const response = await api.get(`/api/v1/admin/api-logs?lineLimit=${lineLimit}`);
    return response.data;
  } catch (error) {
    console.log(error);
    return {
      error: true,
      message: error?.response?.data?.message || "Failed to fetch API logs",
      data: {
        entries: [],
        loadedLineCount: 0,
        totalLineCount: 0,
        lineLimit,
        availableLineLimits: [100, 200, 500, 1000],
      },
    };
  }
}
